import React from "react";

export const OTP_VERIFY_INPUT_STYLES = `
.login-otp-fields {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 14px;
  width: 100%;
}

.login-otp-box {
  position: relative;
  width: 58px;
  height: 76px;
  flex-shrink: 0;
}

.login-otp-box input {
  width: 45px !important;
  height: 49px !important;
  margin: 0 !important;
   border: 2px solid #2bb24b !important;
  border-radius: 17px !important;
  background: #fff !important;
  text-align: center !important;
  font-size: 1rem !important; 
  color: #1a1a1a !important;
  outline: none !important;
  box-shadow: none !important;
  line-height: 1 !important;
  -moz-appearance: textfield;
}

.login-otp-box input::-webkit-outer-spin-button,
.login-otp-box input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.login-otp-box input:focus {
  border-color: #0d5d29 !important;
}

.login-otp-box::after {
  content: "";
  position: absolute;
  bottom: 40px;
  left: 39%;
  transform: translateX(-50%);
  width: 20px;
  height: 2.5px;
  background: #8a8a8a;
  border-radius: 2px;
  pointer-events: none;
}

.login-otp-box--filled::after {
  opacity: 0;
}
`;

export const OTP_INPUT_CONTAINER_STYLE = "login-otp-fields";

export function createOtpRenderInput({ getCurrentOtp, onEnter, onKeyPressValidate }) {
  return (inputProps, index) => {
    const { style: _libraryStyle, className: _libraryClass, value, ...rest } = inputProps;
    const hasDigit = String(value ?? "").length > 0;

    return (
      <div
        className={`login-otp-box${hasDigit ? " login-otp-box--filled" : ""}`}
      >
        <input
          {...rest}
          value={value}
          type="tel"
          inputMode="numeric"
          pattern="[0-9]*"
          autoComplete={index === 0 ? "one-time-code" : "off"}
          enterKeyHint={index === 3 ? "go" : "next"}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.keyCode === 13) {
              e.preventDefault();
              const currentOtp = getCurrentOtp();
              if (String(currentOtp).trim().length === 4) {
                onEnter();
              }
              return;
            }
            rest.onKeyDown?.(e);
            const allowedKeyCodes = [8, 9, 46];
            if (!allowedKeyCodes.includes(e.keyCode)) {
              if (e.keyCode < 48 || e.keyCode > 57) {
                e.preventDefault();
              }
            }
          }}
          onKeyPress={onKeyPressValidate}
        />
      </div>
    );
  };
}
